/* mini-shop-the-look.js — v2: prickar, tooltip, koppling till listan och Köp hela serien */
(function () {
  'use strict';
  var OFFSET = 10;

  function init(root) {
    root.querySelectorAll('[data-mstl]').forEach(function (sec) {
      if (sec.dataset.mstlReady) return;
      sec.dataset.mstlReady = '1';
      sec.querySelectorAll('.mstl-hotspot').forEach(function (btn) {
        var id = btn.dataset.hotspotId;
        var row = sec.querySelector('[data-mstl-row="' + id + '"]');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var tip = document.getElementById('mstl-tip-' + id);
          if (!tip) return;
          var wasOpen = !tip.hidden;
          closeAll(sec);
          if (!wasOpen) open(btn, tip, row);
        });
        btn.addEventListener('mouseenter', function () { active(btn, row, true); });
        btn.addEventListener('mouseleave', function () { if (btn.getAttribute('aria-expanded') !== 'true') active(btn, row, false); });
        if (row) {
          row.addEventListener('mouseenter', function () { active(btn, row, true); });
          row.addEventListener('mouseleave', function () { if (btn.getAttribute('aria-expanded') !== 'true') active(btn, row, false); });
        }
      });
    });
  }

  function active(btn, row, on) { btn.classList.toggle('is-active', on); if (row) row.classList.toggle('is-active', on); }

  function open(btn, tip, row) {
    tip.hidden = false; tip.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true'); active(btn, row, true);
    var wrap = btn.closest('.mstl-image-wrap');
    var w = wrap.getBoundingClientRect(), b = btn.getBoundingClientRect();
    var px = b.left + b.width / 2 - w.left, py = b.top + b.height / 2 - w.top;
    tip.style.left = '0px'; tip.style.top = '0px';
    var tw = tip.offsetWidth, th = tip.offsetHeight;
    var left = px + OFFSET + b.width / 2;
    if (left + tw > w.width - 8) left = px - OFFSET - b.width / 2 - tw;
    left = Math.max(8, Math.min(left, w.width - tw - 8));
    var top = Math.max(8, Math.min(py - th / 2, w.height - th - 8));
    tip.style.left = Math.round(left) + 'px'; tip.style.top = Math.round(top) + 'px';
  }

  function close(tip) {
    tip.hidden = true; tip.classList.remove('is-open');
    var id = tip.id.replace('mstl-tip-', '');
    var sec = tip.closest('[data-mstl]');
    var btn = sec && sec.querySelector('[data-hotspot-id="' + id + '"]');
    var row = sec && sec.querySelector('[data-mstl-row="' + id + '"]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); active(btn, row, false); }
  }

  function closeAll(scope) { (scope || document).querySelectorAll('.mstl-tooltip.is-open').forEach(close); }

  document.addEventListener('click', function (e) {
    var c = e.target.closest('.mstl-tooltip__close');
    if (c) { close(c.closest('.mstl-tooltip')); return; }
    if (!e.target.closest('.mstl-hotspot') && !e.target.closest('.mstl-tooltip')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mstl-buyall]');
    if (!btn || btn.classList.contains('is-loading')) return;
    var ids = (btn.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var msg = btn.parentNode.querySelector('.mstl-buyall__msg');
    if (msg) msg.textContent = '';
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) { window.location.href = root + 'cart'; return; }
        throw new Error(res.data && (res.data.description || res.data.message));
      })
      .catch(function (err) {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        if (msg) msg.textContent = (err && err.message) ? err.message : 'Något gick fel. Försök igen eller lägg till produkterna en och en.';
      });
  });

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
